<template>
  <full-container v-loading="loading" :padding="0">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.keyWord" placeholder="名称关键字" clearable />
        </el-form-item>
        <el-button type="primary" size="small" @click="onSearch">查询</el-button>
      </el-form>
    </div>
    <!--表格-->
    <el-table ref="tb" :data="datalist.Items" height="100%" style="height: 100%">
      <el-table-column type="selection" width="60" align="center" />
      <el-table-column prop="Name" label="接口名称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="Url" label="接口地址" min-width="200" show-overflow-tooltip />
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-button type="primary" icon="el-icon-s-promotion" @click="onSubmit">保存授权</el-button>
      <el-pagination :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onPager" />
    </div>
  </full-container>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      authorizes: [],
      currents: [],
      datalist: {},
      queryParams: {
        page: 1,
        size: 20,
        identity: true,
        authorize: true,
        state: true
      },
    }
  },
  props: {
    mode: { type: Number, default: null },
    targetId: { type: String, default: null },
  },
  created () {
    //先获取到权限
    this.$apis.system.authorize.getList({
      mode: this.mode,
      targets: [this.targetId],
      types: [1],
    }).then((res) => {
      this.authorizes = res
      this.loadData()
    }).catch((e) => {
      this.$message.error(e)
    })
  },
  methods: {
    // 查询参数
    onSearch () {
      this.queryParams.index = 1
      this.loadData()
    },
    // 分页触发事件
    onPager (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$apis.system.action.getList(this.queryParams).then((res) => {
        this.datalist = res
      }).then(() => {
        this.currents = []
        this.$refs['tb'].data.map((row) => {
          if (this.authorizes.filter((item) => item == row.Id).length > 0) {
            this.$refs['tb'].toggleRowSelection(row)
            this.currents.push(row.Id)
          }
        })
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },

    onSubmit () {
      if (this.loading) { return }
      this.loading = true

      //当前选中的
      let actions = this.$refs['tb'].selection.map((row) => {
        return row.Id
      })
      let inserts = [...actions].filter((x) =>
        [...this.currents].every((y) => y !== x)
      )
      let removes = [...this.currents].filter((x) =>
        [...actions].every((y) => y !== x)
      )
      this.$apis.system.authorize.submit({
        Mode: this.mode,
        Type: 1,
        Target: this.targetId,
        Inserts: inserts,
        Removes: removes,
      }).then(() => {
        //回填权限
        this.currents = [...this.currents, ...inserts].filter(x => [...removes].every(y => y !== x))
        this.authorizes = [...this.authorizes, ...inserts].filter(x => [...removes].every(y => y !== x))
        this.$message({ message: '设置成功！', type: 'success' })
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
